import { put, takeLatest, select, all } from 'redux-saga/effects'
import { signalrEvents, signalrConstants } from '@tabeeb/modules/signalr'
import { addEditedAnswer, onContentReviewCompleted, onReviewFeedbackSent } from '@tabeeb/modules/contentReviews/actions'
import { SagaIterator } from 'redux-saga'

import { Action } from 'redux-actions'
import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'
import * as rawActions from '../actions'
import { deleteGalleryItemSuccess, onDeleteGalleryItem } from '../../gallery/actions'
import { getIsCurrentUserReviewer } from '../../../users/selectors'
import { getCurrentForm, getIsContentFormOnReview } from '../selectors'
import { FormControlAnswer } from '../types'

function* setAnswersStatusesCount(action: ReturnType<typeof rawActions.getAnswersStatusesCount.success>): SagaIterator {
  const { data } = action.response
  if (!data) {
    return
  }
  yield put(rawActions.setAnswersStatusesCount(data.FormAnswerStatuses!))
}

function* getAnswersStatusesCount() {
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)
  if (currentForm?.ContentFormId) {
    yield put(rawActions.getAnswersStatusesCount.request({ contentFormId: currentForm.ContentFormId }))
  }
}

function* onAnswerStatusUpdatedByReviewer(action: Action<[FormControlAnswer]>): SagaIterator {
  const [updatedAnswer] = action.payload
  const isReviewer: ReturnType<typeof getIsCurrentUserReviewer> = yield select(getIsCurrentUserReviewer)

  if (isReviewer) {
    yield put(addEditedAnswer(updatedAnswer))
    yield put(rawActions.updateAnswerStatus(updatedAnswer))
  }
}

function* setFormAnswerStatus(action: ReturnType<typeof rawActions.setFormAnswerStatus>): SagaIterator {
  let statusModel = action.payload
  const isReviewer: ReturnType<typeof getIsCurrentUserReviewer> = yield select(getIsCurrentUserReviewer)

  if (isReviewer) {
    yield put(rawActions.updateReviewerAnswerStatus.request(statusModel))
  } else {
    const isFormOnReview: ReturnType<typeof getIsContentFormOnReview> = yield select(getIsContentFormOnReview)
    if (
      isFormOnReview &&
      (statusModel.FormAnswerStatus === FormAnswerStatus.Pass || statusModel.FormAnswerStatus === FormAnswerStatus.Fail)
    ) {
      const reviewStatusesMap = {
        [FormAnswerStatus.Pass]: FormAnswerStatus.ApprovedByReviewer,
        [FormAnswerStatus.Fail]: FormAnswerStatus.RejectedByReviewer,
      }

      statusModel = { ...statusModel, FormAnswerStatus: reviewStatusesMap[statusModel.FormAnswerStatus] }
    }

    yield put(rawActions.apiUpdateAnswerStatus.request(statusModel))
  }
}

function* formAnswersStatus() {
  yield all([
    takeLatest(rawActions.getAnswersStatusesCount.success, setAnswersStatusesCount),
    takeLatest(
      [deleteGalleryItemSuccess, onDeleteGalleryItem, onReviewFeedbackSent, onContentReviewCompleted],
      getAnswersStatusesCount
    ),
    takeLatest(
      signalrEvents[signalrConstants.tabeebHubName].onAnswerStatusUpdatedByReviewer,
      onAnswerStatusUpdatedByReviewer
    ),
    takeLatest(rawActions.setFormAnswerStatus, setFormAnswerStatus),
  ])
}

export default formAnswersStatus
